// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ku-3";
export var downloadButton = "_ku-4";
export var fileContainer = "_ku-9 _ku-7";
export var fileContainerBase = "_ku-7";
export var fileContainerFixedHeight = "_ku-8 _ku-7";
export var fileInfo = "_ku-5";
export var fileInfoWidthRestricted = "_ku-6";
export var fileType = "_ku-1";
export var fileTypeName = "_ku-2";
export var image = "_ku-0";
export var link = "_ku-b";
export var overflowEllipsis = "_ku-a";